"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkTabs = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const TabContent_1 = require("../TabContent");
const inventory_1 = require("../../theme/inventory");
const LinkTabTitle_1 = __importDefault(require("./LinkTabTitle"));
const constants_1 = require("./constants");
const LinkTabs = props => {
  const {
    children,
    bgColor,
    contentBgColor,
    sliderColor,
    onClick,
    fixed,
    mobile
  } = props;
  const [selectedTab, setSelectedTab] = react_1.default.useState(0);
  let activeTab = children ? children.findIndex(item => item.props.selected) : -1;
  if (children && activeTab === -1) {
    activeTab = 0;
  }
  const [selectedTabWidth, setSelectedTabWidth] = react_1.default.useState(0);
  const [selectedTabLeft, setSelectedTabLeft] = react_1.default.useState(0);
  const onSelected = (tabIndex, ref) => {
    if (onClick) {
      if (children && tabIndex > -1) {
        // @ts-ignore
        onClick({
          ...children[tabIndex].props,
          ref
        });
      }
    } else {
      setSelectedTab(tabIndex);
    }
    if (ref?.current) {
      setSelectedTabWidth(ref.current.offsetWidth - constants_1.SLIDER_DIF_VALUE * 2);
      setSelectedTabLeft(ref.current.offsetLeft + constants_1.SLIDER_DIF_VALUE);
    }
  };
  const onSetTabSlider = ref => {
    if (ref.current) {
      setSelectedTabWidth(ref.current.offsetWidth - constants_1.SLIDER_DIF_VALUE * 2);
      setSelectedTabLeft(ref.current.offsetLeft + constants_1.SLIDER_DIF_VALUE);
    }
  };
  let content;
  if (children) {
    if (onClick) {
      // @ts-ignore
      content = children[activeTab].props.children;
    } else {
      // @ts-ignore
      content = children[selectedTab].props.children;
    }
  }
  return (0, jsx_runtime_1.jsxs)(styles_1.StyledTabsWrapper, {
    fixed: fixed,
    mobile: mobile,
    isLinkTab: true,
    className: 'tabs-secondary',
    children: [(0, jsx_runtime_1.jsxs)(styles_1.StyledTabs, {
      bgColor: inventory_1.GENERAL_COLOR_VALUES.white,
      children: [children?.map((item, index) => {
        return (0, jsx_runtime_1.jsx)(LinkTabTitle_1.default, {
          title: item.props.title,
          tabIndex: index,
          onSelect: onSelected,
          isSelected: index === (onClick ? activeTab : selectedTab),
          badgeValue: item.props.badgeValue,
          bgColor: props.bgColor,
          isDefaultSelected: selectedTabWidth === 0 && selectedTabLeft === 0 && (index === selectedTab || index === activeTab),
          onSetTabSlider: onSetTabSlider,
          name: item.props.name,
          badgeProps: item.props.badgeProps,
          mobile: mobile
        }, `tab-${index}`);
      }), (0, jsx_runtime_1.jsx)(styles_1.StyledSlider, {
        sliderColor: !children ? inventory_1.GENERAL_COLOR_VALUES.white : bgColor || sliderColor,
        width: selectedTabWidth,
        left: selectedTabLeft,
        "aria-label": 'slider'
      })]
    }), (0, jsx_runtime_1.jsx)(TabContent_1.TabContent, {
      bgColor: contentBgColor,
      children: content
    })]
  });
};
exports.LinkTabs = LinkTabs;